<div class="row">
  <div *ngFor="let item of items" class="col-12">
    <ng-template libCustomHost></ng-template>
  </div>
</div>
